import styled from '@emotion/native'

export const ItemContainer = styled.TouchableOpacity(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.sizes.sm,
  alignItems: 'center',
  paddingVertical: theme.sizes.sm,
  borderBottomWidth: 1,
  borderBottomColor: '#e0e0e0',
}))

export const InfoContainer = styled.View(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
  gap: 12, // Fixed gap instead of theme.sizes.sm
}))

export const StatusContainer = styled.View(() => ({
  flexDirection: 'row',
  gap: 8, // Fixed gap instead of theme.sizes.xs
  marginTop: 8, // Fixed margin instead of theme.sizes.xs
}))

export const StatusBadge = styled.View<{ isMandatory?: boolean; isUpToDate?: boolean; isPeriodicity?: boolean }>(({ theme, isMandatory, isUpToDate, isPeriodicity }) => ({
  paddingHorizontal: theme.sizes.xs,
  paddingVertical: 2,
  borderRadius: 4,
  backgroundColor: isPeriodicity
    ? '#e3f2fd'
    : (isMandatory !== undefined
      ? (isMandatory ? '#ffebee' : '#f5f5f5')
      : (isUpToDate ? '#e8f5e8' : '#fff3cd')),
  borderWidth: 1,
  borderColor: isPeriodicity
    ? '#2196f3'
    : (isMandatory !== undefined
      ? (isMandatory ? '#f44336' : '#e0e0e0')
      : (isUpToDate ? '#4caf50' : '#ff9800')),
}))

export const ButtonContainer = styled.View(() => ({
  marginLeft: 'auto',
  justifyContent: 'center',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
}))

export const WarningContainer = styled.View(({ theme }) => ({
  backgroundColor: '#ff9800',
  borderColor: '#e65100',
  borderWidth: 1,
  borderRadius: 8,
  padding: theme.sizes.sm,
  marginBottom: theme.sizes.sm,
  width: '100%',
}))

export const ColumnContainer = styled.View(() => ({
  flexDirection: 'column',
  flex: 1,
}))

export const IconContainer = styled.View(() => ({
  width: 24,
  alignItems: 'center',
  justifyContent: 'center',
}))

export const TableHeader = styled.View(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  paddingVertical: 12,
  paddingHorizontal: 16,
  backgroundColor: '#f5f5f5',
  borderBottomWidth: 2,
  borderBottomColor: '#e0e0e0',
  gap: 12,
}))

export const TableRow = styled.View(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  paddingVertical: 12,
  paddingHorizontal: 16,
  borderBottomWidth: 1,
  borderBottomColor: '#e0e0e0',
  gap: 12,
}))

export const StatusColumn = styled.View<{ isMobile?: boolean; }>(({isMobile=false}) => ({
  width: isMobile ? 20 : 70,
  alignItems: 'center',
  justifyContent: 'center',
}))

export const TypeColumn = styled.View(() => ({
  width: 40,
  alignItems: 'center',
  justifyContent: 'center',
}))

export const TypeCircle = styled.View<{ isMandatory: boolean }>(({ isMandatory }) => ({
  width: 16,
  height: 16,
  borderRadius: 8,
  backgroundColor: isMandatory ? '#ff9800' : '#666666',
}))

export const VaccineColumn = styled.View<{ isMobile?: boolean; }>(({isMobile=false}) => ({
  flex: 1,
  minWidth: 0,
  paddingLeft: isMobile ? 25 : 0,
}))

export const PeriodicityColumn = styled.View(() => ({
  width: 120,
  alignItems: 'center',
}))

export const MandatoryColumn = styled.View<{ isMobile?: boolean; }>(({isMobile=false}) => ({
  width: isMobile ? 200 : 120,
  alignItems: isMobile ? 'flex-end' : 'center',
}))

export const RenewalColumn = styled.View(() => ({
  width: 120,
  alignItems: 'center',
}))

export const HistoryColumn = styled.View<{ isMobile?: boolean; }>(({isMobile=false}) => ({
  width: isMobile ? 60 : 100,
  alignItems: isMobile ? 'flex-end' : 'center',
}))


export const StatusCircle = styled.View<{ isMandatory: boolean; isUpToDate: boolean }>(({ isMandatory, isUpToDate }) => ({
  width: 28,
  height: 28,
  borderRadius: 14,
  backgroundColor: 'white',
  alignItems: 'center',
  justifyContent: 'center',
  borderWidth: 2,
  borderColor: isMandatory ? '#ff9800' : '#666666',
}))

export const MobileCard = styled.TouchableOpacity(() => ({
  backgroundColor: 'white',
  borderRadius: 8,
  padding: 16,
  marginBottom: 8,
  borderWidth: 1,
  borderColor: '#e0e0e0',
  width: '100%',
}))

export const MobileCardHeader = styled.View(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 8,
  gap: 12,
}))

export const MobileCardContent = styled.View(() => ({
  gap: 4,
}))

export const MobileCardRow = styled.View(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}))
